export default "__VITE_ASSET__DQrdZ40z__"